<template>
      <div class="mask" >
       	<div class="acceptbottom">
            <div class="accepttitle" v-html="$t('accept.title')"></div>
            <div class="acceptbtn">
              <p @click="close">{{ $t('accept.decline') }}</p>
              <p class="acceptsuccess" @click="allow">{{ $t('accept.accept') }}</p>
            </div>
       	</div>
    </div>
</template>

<script>
  import { mapGetters,mutations } from 'vuex'
  export default {

    data() {
       return {

       }
    },
    methods:{
      close(){
        this.$store.commit('SET_ACCEPT',false)
        this.$emit('close')
      },
      allow(){
        localStorage.setItem('acceptis',true)
        this.$store.commit('SET_ACCEPT',true)
        this.$emit('close')
      }
    }
  }
</script>

<style scoped>

  .acceptbottom{
    background-color: #FFFFFF;
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    max-width: 750px;
    width: 90%;
  }
  .accepttitle{
    /* height: 9rem; */
    font-size: 1rem;
    padding: 1.25rem 2.5rem 32px 2.5rem;
    line-height: 1.25rem;
    margin-top: 0.625rem;
    font-weight: 500;
    color: #404D5E;
    text-align: justify;
  }
  .acceptbtn{
    display: flex;
    padding: 0 2.5rem;
    justify-content: space-between;
  }
  .acceptbtn p{
    width: 30%;
    text-align: center;
    margin-bottom: 1.875rem;
    font-size: 1rem;
    border: 1px solid #293549;
    border-radius: 0.3125rem;
    line-height: 3.125rem ;
    height: 3.125rem;
  }
  .acceptbtn .acceptsuccess{
    background-color: #3BE487;
    border: 1px solid #3BE487;
    color: #FFFFFF;
    width: 56%;
  }
</style>



// WEBPACK FOOTER //
// src/components/common/accept.vue